import { format } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { type MilestoneStatus, STATUS_STYLES } from './rfp-timeline-types';

interface TimelineLegendProps {
  counts: Record<MilestoneStatus, number>;
  today: Date;
}

const STATUSES: MilestoneStatus[] = ['past', 'active', 'upcoming'];

export const TimelineLegend: FC<TimelineLegendProps> = ({ counts, today }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between gap-4 px-4 py-3 border-b border-day-light-2">
      <div className="flex items-center gap-4 text-sm">
        {STATUSES.map((status) => (
          <span key={status} className="flex items-center gap-2">
            <span className={`inline-block h-2 w-2 rounded-full ${STATUS_STYLES[status].dot}`} />
            <span className="text-day-neutral-subtle">{t(`dashboard.rfp-timeline.${status}`)}</span>
            <span className="font-semibold text-day-neutral-dark">{counts[status]}</span>
          </span>
        ))}
      </div>
      <span className="text-sm text-day-neutral-subtle">
        {t('dashboard.rfp-timeline.today')}: {format(today, 'd MMM yyyy')}
      </span>
    </div>
  );
};
